<template>
  <div>
    <div class="row">
      <div class="col ml-2" style="max-width: 900px">
        <h5 class="mt-3">Zugriffskontrollliste</h5>
        <hr class="mt-0" />
      </div>
    </div>

    <UserAdminModal @ok="loadUsers" />
    <b-overlay :show="requestPending" variant="white" opacity="1" spinner-variant="primary">
      <div
        class="row pl-3 mt-2 mb-2"
        style="max-width: 900px"
        v-for="user of users.filter(x => x.IsSuperAdmin == false)"
        :key="user.UsedId"
      >
        <div class="pl-2 my-auto" style="width: 30px">
          <b-icon
            icon="clock-history"
            title="Der Anwender hat die Einladung noch nicht angenommen."
            v-if="user.InviteAccepted !== 1 && user.InviteExpired !== true"
          />
          <b-icon
            icon="exclamation-triangle"
            title="Die Einladung wurde nicht innerhalb von 5 Tagen angenommen und ist abgelaufen."
            v-if="user.InviteAccepted !== 1 && user.InviteExpired == true"
          />
          <b-icon title="Superadmin" icon="asterisk" v-if="user.IsSuperAdmin == true" />
        </div>
        <div class="col-7 pl-0 my-auto" :class="{ 'font-weight-bold': $root.$user.sub == user.UserId }">
          {{ user.LastName + ', ' + user.FirstName }}
        </div>
        <div class="col-3">
          <div
            class="my-1"
            v-if="!(($root.$user.isAdmin && $root.$user.sub != user.UserId) || $root.$user.isSuperAdmin)"
          >
            <div
              :class="{ 'font-weight-bold': $root.$user.sub == user.UserId }"
              style="font-size: 0.9em; margin-left: 8px; padding-bottom: 1px"
            >
              {{ roleToText(user.selectedRole) }}
            </div>
          </div>
          <b-form-select
            v-model="user.selectedRole"
            :required="true"
            size="sm"
            v-if="($root.$user.isAdmin && $root.$user.sub != user.UserId) || $root.$user.isSuperAdmin"
          >
            <template #first>
              <b-form-select-option :value="null" disabled>-- Berechtigung wählen --</b-form-select-option>
            </template>
            <b-form-select-option value="leser">Leser</b-form-select-option>
            <b-form-select-option value="planer">Assistenz</b-form-select-option>
            <b-form-select-option value="admin">Projektadmin</b-form-select-option>
          </b-form-select>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-right px-0 text-center">
          <b-icon
            icon="check-2"
            role="button"
            title="Änderungen der Benutzerrolle speichern"
            @click="assignRoleToUser(user)"
            style="width: 20px; height: 20px;"
            v-if="($root.$user.isAdmin && $root.$user.sub != user.UserId) || $root.$user.isSuperAdmin"
          />
          <b-icon
            icon="envelope"
            title="Diesem Benutzer erneut eine Einladung per E-Mail senden. "
            role="button"
            @click="reinviteUser(user)"
            v-if="user.InviteExpired == true"
            style="margin-left:15px"
          />
          <b-icon
            icon="trash"
            title="Diesen Benutzer aus dem Projekt entfernen"
            role="button"
            style="margin-left:15px"
            @click="deleteProjectUser(user)"
            v-if="($root.$user.isAdmin && $root.$user.sub != user.UserId) || $root.$user.isSuperAdmin"
          />
        </div>
      </div>
      <div class="row pl-3 mt-3" style="max-width: 900px">
        <div class="col pl-4">
          <b-button
            size="sm"
            @click="$bvModal.show('modal-useradmin')"
            variant="secondary"
            v-if="$root.$user.isAdmin || $root.$user.isSuperAdmin"
          >
            Weiteren Benutzer einladen
          </b-button>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
//import AllocationUnitDetailsInvoices from '....\views/AllocationUnitDetailsInvoices.vue';
import AppState from '@/store/App.js';
import ProjectService from '@/service/ProjectsService';
//import AkLookupField from '@/components/AkLookupFieldNoPre';
import UserAdminModal from '@/components/settings/UserAdminModal';
//import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

export default {
  async activated() {
    AppState.isLoading = false;

    // if user is not an admin, redirect him to home. this can happen, if user without permission tries to navigate directly to /settings/useradmin
    if (!this.$root.$user.isAdmin && !this.$root.$user.isPlaner) this.$router.push('/');
    this.loadUsers();
  },
  async deactivated() {},
  components: {
    UserAdminModal
    //VueTypeaheadBootstrap
  },
  data() {
    return {
      //selectedRole: null,
      //selectedUser: null,
      //selectedUserId: null,
      users: [],
      //acladmins: [],
      //aclplaner: [],
      //aclviewer: []
      requestPending: true
    };
  },
  methods: {
    roleToText(role) {
      switch (role) {
        case 'leser':
          return 'Leser';

        case 'planer':
          return 'Assistenz';

        case 'admin':
          return 'Projektadmin';
      }
    },
    assignRoleToUser(user) {
      if (user.selectedRoleBkp == user.selectedRole)
        return this.$bvModal.msgBoxOk('Die Rolle wurde nicht verändert.', {
          title: 'Benutzerrolle ändern',
          centered: true
        });

      var roleText = this.roleToText(user.selectedRole);
      var roleBkpText = this.roleToText(user.selectedRoleBkp);

      this.$bvModal
        .msgBoxConfirm(
          'Soll für den Benutzer "' +
            user.DisplayName +
            '" wirklich die Rolle von "' +
            roleBkpText +
            '" auf "' +
            roleText +
            '" geändert werden?',
          {
            title: 'Benutzerrolle ändern',
            okTitle: 'Bestätigen',
            cancelTitle: 'Abbrechen',
            okVariant: 'danger',

            centered: true
          }
        )
        .then(confirmed => {
          if (confirmed) {
            ProjectService.updateACLUser(user.UserId, user.selectedRole)
              .then(() => {
                this.loadUsers();
                user.selectedRoleBkp = user.selectedRole;
                this.$showSuccess(
                  this,
                  'Benutzerrolle ändern',
                  'Rolle "' + roleText + '" erfolgreich dem Benutzer "' + user.DisplayName + ' zugewiesen.'
                );
              })
              .catch(err => {
                if (err.response) this.$showError(this, err.response.data.error);
                else this.$showError(this, err.toString());
              });
          }
        });
    },
    addUser() {
      if (!this.$refs.addUserForm.checkValidity()) {
        return this.$refs.addUserForm.reportValidity();
      }
      ProjectService.addACLUser(this.selectedUserId, this.selectedRole)
        .then(() => {
          this.loadACLUsers();
          this.$showSuccess(
            this,
            'Benutzer hinzufügen',
            'Benutzer "' + this.selectedUser + ' erfolgreich hinzugefügt.'
          );
          this.selectedUserId = null;
          this.selectedUser = '';
          this.selectedRole = null;
          this.$forceUpdate();
        })
        .catch(err => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.error &&
            err.response.data.error.errno &&
            err.response.data.error.errno == 1062
          ) {
            this.$showError(this, 'Benutzer "' + this.selectedUser + '" ist bereits eingetragen.');
          } else if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
    },
    async loadUsers() {
      this.requestPending = true;
      ProjectService.getUsersByProject()
        .then(users => {
          this.users = users;
          this.users.map(user => {
            user.selectedRole = 'leser';
            if (user.IsPlaner) user.selectedRole = 'planer';
            if (user.IsAdmin) user.selectedRole = 'admin';
            user.selectedRoleBkp = user.selectedRole;
            return user;
          });
        })
        .finally(() => (this.requestPending = false));
    },
    deleteProjectUser(user) {
      this.$bvModal
        .msgBoxConfirm('Soll der Benutzer "' + user.DisplayName + '" wirklich aus dem Projekt entfernt werden?', {
          title: 'Benutzer entfernen',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(confirmed => {
          if (confirmed) {
            ProjectService.deleteProjectUser(user.UserId).then(() => {
              this.loadUsers();
              //this.users.push(user);
              this.$nextTick(() => {
                this.$utils.sortArray(this.users, 'DisplayName');
              });

              this.$showSuccess(this, 'Benutzer entfernen', 'Benutzer "' + user.DisplayName + ' erfolgreich entfernt.');
            });
          }
        });
    },
    reinviteUser(user) {
      this.requestPending = true;
      ProjectService.reinviteUser(user.UserId)
        .then(() => {
          user.InviteExpired = false;
          user.InviteAccepted = 0; // reset the invite status
          this.$showSuccess(
            this,
            'Benutzer erneut einladen',
            'Der Benutzer "' + user.DisplayName + '" wurde erneut eingeladen.'
          );
        })
        .finally(() => {
          this.requestPending = false;
        });
    }
  }
};
</script>

<style>
.vbt-autcomplete-list {
  /*top: 62px !important;*/
  margin-top: 0px !important;
  padding-top: 0 !important;
}

.vbst-item {
  padding-left: 13px !important;
}
</style>
